import { useEffect } from "react";

export default function useMobileNav() {
  useEffect(() => {
    const toggleBtn = document.querySelector(".mobile-nav-toggle");

    const toggleNav = () => {
      document.body.classList.toggle("mobile-nav-active");
      toggleBtn.classList.toggle("bi-list");
      toggleBtn.classList.toggle("bi-x");
    };

    if (toggleBtn) toggleBtn.addEventListener("click", toggleNav);

    return () => {
      if (toggleBtn) toggleBtn.removeEventListener("click", toggleNav);
    };
  }, []);
}
